/**
 * DecisionsRoute: `/decisions` and `/decisions/:decisionId`. A thin wrapper
 * so tests can mount the page without importing main.tsx.
 */
import { DecisionsPage } from "./DecisionsPage.js";

export function DecisionsRoute() {
  return <DecisionsPage />;
}
